let measureCanvas = null

const NAV_LINK_GAP_PX = 32
const MAIN_GAP_PX = 12

export const measureTextWidth = (text, font) => {
  if (!text) return 0

  if (!measureCanvas) {
    measureCanvas = document.createElement('canvas')
  }

  const context = measureCanvas.getContext('2d')
  context.font = font
  return context.measureText(text).width
}

export const getFontFromElement = (element) => {
  if (!element) return '700 18px sans-serif'

  const style = window.getComputedStyle(element)
  return `${style.fontWeight} ${style.fontSize} ${style.fontFamily}`
}

export const estimateRequiredNavWidth = (navbar, links) => {
  if (!navbar) return 0

  let total = 0

  const logo = navbar.querySelector('.logo-link')
  if (logo) {
    total += logo.getBoundingClientRect().width + MAIN_GAP_PX
  }

  if (links) {
    const navLinks = Array.from(links.querySelectorAll('.navbar-link'))
    navLinks.forEach((link, index) => {
      const labelSpan = link.querySelector(':scope > span')
      if (!labelSpan) return

      let width = Math.ceil(
        measureTextWidth(labelSpan.textContent?.trim(), getFontFromElement(labelSpan)),
      )
      if (link.querySelector('.edit-icon-wrapper')) {
        width += 32
      }
      total += width
      if (index < navLinks.length - 1) {
        total += NAV_LINK_GAP_PX
      }
    })
    if (navLinks.length) {
      total += MAIN_GAP_PX
    }
  }

  const inbox = navbar.querySelector('#navbar-link-announcements')
  if (inbox && !inbox.classList.contains('hidden') && inbox.offsetParent !== null) {
    let inboxWidth = 64
    const inboxSpan = inbox.querySelector(':scope > span')
    if (inboxSpan?.textContent?.trim()) {
      inboxWidth += 8 + Math.ceil(
        measureTextWidth(inboxSpan.textContent.trim(), getFontFromElement(inboxSpan)),
      )
    }
    total += inboxWidth
    total += MAIN_GAP_PX
  }

  const signOut = navbar.querySelector('.sign-out')
  if (signOut && signOut.offsetParent !== null) {
    total += Math.ceil(
      measureTextWidth(signOut.textContent?.trim(), getFontFromElement(signOut)),
    )
  }

  return total
}
